import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { X } from 'lucide-react';

export const LanguageChoiceBar = () => {
    const { language } = useLanguage();
    const navigate = useNavigate();
    const [visible, setVisible] = useState(() => {
        try { return !localStorage.getItem('bestbuddy_lang_chosen'); } catch (_e) { return false; }
    });
    if (!visible) return null;

    const remember = (lang) => {
        try { localStorage.setItem('bestbuddy_lang_chosen', lang); } catch (_e) { /* ignore */ }
        setVisible(false);
    };
    const choose = (lang) => {
        remember(lang);
        navigate(lang === 'en' ? '/en' : '/', { replace: true, state: { lang } });
    };

    return (
        <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40" data-testid="language-choice-bar">
            <div className="flex items-center gap-1.5 rounded-full border border-border bg-background/90 backdrop-blur-md px-3 py-2 shadow-lg">
                <span className="text-xs text-muted-foreground pl-1 pr-0.5">
                    {language === 'de' ? 'Sprache:' : 'Language:'}
                </span>
                <button
                    onClick={() => choose('de')}
                    className={`rounded-full px-3 py-1 text-xs font-semibold transition-colors ${language === 'de' ? 'bg-primary text-primary-foreground' : 'hover:bg-secondary'}`}
                    data-testid="lang-bar-de"
                >
                    🇩🇪 Deutsch
                </button>
                <button
                    onClick={() => choose('en')}
                    className={`rounded-full px-3 py-1 text-xs font-semibold transition-colors ${language === 'en' ? 'bg-primary text-primary-foreground' : 'hover:bg-secondary'}`}
                    data-testid="lang-bar-en"
                >
                    🇬🇧 English
                </button>
                <button
                    onClick={() => remember(language)}
                    className="p-1 text-muted-foreground hover:text-foreground transition-colors"
                    aria-label="Close"
                    data-testid="lang-bar-close"
                >
                    <X className="w-3.5 h-3.5" />
                </button>
            </div>
        </div>
    );
};
